// extracted by mini-css-extract-plugin
export var linkText = "_ol-0";